<template>
    <div>

        <header class="blue filter">
            <div class="container">
				<div class="row align-items-end">
					<div class="col-sm-6">

						<h1>KLINGER Dichtungstechnik material finder</h1>
						<h2>Finding KLINGER products made easy</h2>

					</div>
					<div class="col-sm-6">
					</div>
				</div>
            </div>
        </header>

        <!-- <section class="breadcrumbs">
            <div class="container">
                <router-link :to="'/'">KLINGER Dichtungstechnik finder</router-link>
                <span> > </span>
                <span>Products</span>
            </div>
        </section> -->

        <!-- <p>
            The Materialfinder is only available in english language
        </p> -->

        <section class="toolbar">
            <div class="container">
                <section class="row justify-content-between">
                    <div class="col-md-3 col-sm-6">
                        <v-select :placeholder="'Medium' | translate" label="title" v-model="form.medium" @input="onChange" :options="medium"></v-select>
                    </div>
                    <div class="col-md-2 col-sm-6">
                        <v-select :placeholder="'Temperature' | translate" v-model="form.temperature" @input="onChange" :options="temperature"></v-select>
                    </div>
                    <div class="col-md-2 col-sm-6">
                        <v-select :placeholder="'Pressure' | translate" v-model="form.pressure" @input="onChange" :options="pressure"></v-select>
                    </div>
                    <!-- <div class="col-md-2 col-sm-6"> -->
                        <!-- <v-select placeholder="Material Structure' | translate" multiple @input="onChange" :options="['foo','bar']"></v-select> -->
                    <!-- </div> -->
                    <div class="col-md-3 col-sm-6">
                        <v-select :placeholder="'Certificates' | translate" multiple label="title" v-model="form.certificate" @input="onChange" :options="certificate"></v-select>
                    </div>
                    <!-- <div class="col-md-2 col-sm-6">
                        <v-select placeholder="Sealing performance' | translate" v-model="form.sealing" @input="onChange" :options="performance"></v-select>
                    </div> -->
                    <div class="col-md-2 col-sm-6">
                        <v-select :placeholder="'Performance' | translate" v-model="form.tightness" @input="onChange" :options="performance"></v-select>
                    </div>
                </section>
            </div>
        </section>

        <section class="material-list">
			<div class="container">
                <div v-if="loading" class="loader">
                    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                </div>
				<div class="row justify-content-start" v-if="!loading && !filteredMaterials">
					<div class="col-md-3" v-for="(material, index) in materials" :key='index'>
						<article>
							<router-link :to="'/material/'+material.id">
                                <img :src="material.product_image" alt="">
                                <span>{{ getProp(material, 'title') }}</span>
                            </router-link>
						</article>
					</div>
				</div>
                <div class="row justify-content-start" v-if="!loading && filteredMaterials && !filteredMaterials.length">
                    {{'No materials' | translate}}
                </div>
				<div class="row justify-content-start" v-if="!loading && filteredMaterials && filteredMaterials.length">
					<div class="col-md-3" v-for="(material, index) in filteredMaterials" :key='index'>
						<article>
							<router-link :to="'/material/'+material.id">
                                <img :src="material.product_image" alt="">
                                <span>{{ getProp(material, 'title') }}</span>
                            </router-link>
						</article>
					</div>
				</div>
			</div>
        </section>
    </div>
</template>

<script>
// @ is an alias to /src
import vSelect from 'vue-select'
import * as _ from 'lodash';

const decodeHTML = function(str) {
    return str.replace(/&#(\d+);/g, function(match, dec) {
        return String.fromCharCode(dec);
    });
}

export default {
    name: 'MaterialFilter',
    components: {
        vSelect
    },
    data: () => {
        const form = JSON.parse(localStorage.getItem("filterForm") || '{}')
        return {
            loading: false,
            filteredMaterials: null,
            form: {
                medium: form.medium || null,
                temperature: form.temperature || null,
                pressure: form.pressure || null,
                certificate: form.certificate || null,
                sealing: form.sealing || null,
                tightness: form.tightness || null
            }
        }
    },
    mounted() {
        this.filterMaterials()
    },
    methods: {
        getProp(o, prop) {
            return this.$root.locale === 'de_DE' ? (o["de_" + prop] || o[prop]) : o[prop]
        },
        onChange(){
            this.simulateLoader();
            this.filterMaterials();
        },
        simulateLoader() {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 600)
        },
        filterMaterials() {
            let filterProps = Object.assign({}, this.form);
            localStorage.setItem("filterForm", JSON.stringify(filterProps))
            this.filteredMaterials = [];
            let formProps = Object.values(this.form);
            let isFormEmpty = formProps.find((prop) => {
                if (prop && prop.length !== 0) {
                    return true;
                } else if(prop && prop.length === undefined) {
                    return true;
                } else {
                    return false;
                }
            });


            if (!isFormEmpty) {
                this.filteredMaterials = null; 
                return
            };

            this.filteredMaterials = this.materials
            
            .filter((material) => {
                // pressure
                if (this.form.pressure || this.form.temperature) {
                    // find closest temperature and pressure values for pT formula
                    let temp = this.form.temperature ? +this.form.temperature.value : 20;
                    let pressure = this.form.pressure ? +this.form.pressure.value : 10;
                    let entryIndex;
                    let pt2mm = material.pt2mm && material.pt2mm.length && [...material.pt2mm].reverse() || [];
                    
                    // pt1mm2 update
                    // if material has special pT values for specific medium
                    // then use this info istead of general pt1mm/pt2mm/pt3mm info
                    if(this.form.medium && material.pt1mm2) {
                        let materialSpecialPt = material.pt1mm2.filter((e) => {
                            return e.ms_chemical == this.form.medium.id
                        });
                        if(materialSpecialPt && materialSpecialPt.length) {
                            pt2mm = materialSpecialPt.map((e) => {
                                return {
                                    key: e.ms_temperature,
                                    value: e.ms_mpa
                                }
                            })
                        }
                    }

                    pt2mm = pt2mm.sort(function(a, b) {
                        var valA = Number(a['key'])
                        var valB = Number(b['key'])
                        
                        if (valA < valB) {
                            return -1;
                        }

                        if (valA > valB) {
                            return 1;
                        }

                        return 0;
                    });

                    let entry1 = _.find(pt2mm, (entry, i) => {
                        // key - temperature
                        // value - pressure
                        entryIndex = i;
                        return +entry.key >= temp;
                    });
                    if (!entry1) {
                        return false;
                        // entry1 = pt2mm[0];
                    }
                    let entry2 = pt2mm[entryIndex-1];

                    // no data for that temperature
                    let formula;
                    if (!entry2) {
                        formula = +entry1.value
                    } else {
                        // (Filter.iT - mT) * (mP - mP2) / (mT - mT2) + mP;
                        formula = (temp - +entry1.key) * (+entry1.value - +entry2.value) / (+entry1.key - +entry2.key) + +entry1.value;
                    }
                    
                    return pressure <= formula ? true : false;

                } else {
                    return true;
                }
            }).filter((material) => {
                // medium
                if (this.form.medium) {
                    if (material.chemicals.find(chemical => chemical.id === this.form.medium.id)) {
                    // if (material.chemicals.some(chemical => this.form.medium.some(c => c.id == chemical.id))) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            }).filter((material) => {
                // certificate
                if (this.form.certificate && this.form.certificate.length) {
                    if (this.form.certificate.every(c => material.certificates.find((mc) => mc.id === c.id))) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            }).filter((material) => {
                // sealing
                if (this.form.sealing) {
                    if (material.sealing === this.form.sealing.value) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            }).filter((material) => {
                // tightness
                if (this.form.tightness) {
                    if (Number(material.tightness) <= Number(this.form.tightness.value)) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            }).sort((a, b) => Number(a.favorite) - Number(b.favorite));
        }
    },
    computed: {
        temperature() { return [
            {value:'-200', label: '-200 C°'},
            {value:'-150', label: '-150 C°'},
            {value:'-100', label: '-100 C°'},
            {value:'-80', label: '-80 C°'},
            {value:'-60', label: '-60 C°'},
            {value:'-40', label: '-40 C°'},
            {value:'-20', label: '-20 C°'},
            {value:'0', label: '0 C°'},
            {value:'20', label: '20 C°'},
            {value:'40', label: '40 C°'},
            {value:'60', label: '60 C°'},
            {value:'80', label: '80 C°'},
            {value:'100', label: '100 C°'},
            {value:'120', label: '120 C°'},
            {value:'140', label: '140 C°'},
            {value:'150', label: '150 C°'},
            {value:'160', label: '160 C°'},
            {value:'180', label: '180 C°'},
            {value:'200', label: '200 C°'},
            {value:'220', label: '220 C°'},
            {value:'240', label: '240 C°'},
            {value:'250', label: '250 C°'},
            {value:'260', label: '260 C°'},
            {value:'280', label: '280 C°'},
            {value:'300', label: '300 C°'},
            {value:'320', label: '320 C°'},
            {value:'340', label: '340 C°'},
            {value:'360', label: '360 C°'},
            {value:'380', label: '380 C°'},
            {value:'400', label: '400 C°'},
            {value:'450', label: '450 C°'},
            {value:'500', label: '500 C°'},
            {value:'550', label: '550 C°'},
            {value:'600', label: '600 C°'},
            {value:'700', label: '700 C°'},
            {value:'800', label: '800 C°'},
            {value:'900', label: '900 C°'},
            {value:'1000', label: '1000 C°'},
            {value:'1100', label: '1100 C°'},
        ]},
        pressure() { return [
            {value:'1', label: '1 Bar'},
            {value:'5', label: '5 Bar'},
            {value:'10', label: '10 Bar'},
            {value:'15', label: '15 Bar'},
            {value:'20', label: '20 Bar'},
            {value:'25', label: '25 Bar'},
            {value:'30', label: '30 Bar'},
            {value:'35', label: '35 Bar'},
            {value:'40', label: '40 Bar'},
            {value:'45', label: '45 Bar'},
            {value:'50', label: '50 Bar'},
            {value:'55', label: '55 Bar'},
            {value:'60', label: '60 Bar'},
            {value:'65', label: '65 Bar'},
            {value:'70', label: '70 Bar'},
            {value:'75', label: '75 Bar'},
            {value:'80', label: '80 Bar'},
            {value:'90', label: '90 Bar'},
            {value:'100', label: '100 Bar'},
            {value:'120', label: '120 Bar'},
        ]},
        performance() { return [
            {value:1, label: this.$options.filters.translate('1 Best performance')},
            {value:2, label: this.$options.filters.translate('2 or better')},
            {value:3, label: this.$options.filters.translate('3 or better')},
            // {value:4, label: '4'},
            // {value:5, label: '5'}
        ]},
        medium() {
            return _.uniqBy(Object.keys(this.$root.data).reduce((accumulator, current) => {
                return [...accumulator, ...this.$root.data[current].chemicals]
            },[]), 'id').map((chemical) => {
                chemical.title = decodeHTML(this.getProp(chemical, 'title'));
                return chemical
            }).sort(function(a, b) {
                var nameA = a.title.toUpperCase();
                var nameB = b.title.toUpperCase();
                
                if (nameA < nameB) {
                    return -1;
                }

                if (nameA > nameB) {
                    return 1;
                }

                return 0;
            });
        },
        certificate() {
            return _.uniqBy(Object.keys(this.$root.data).reduce((accumulator, current) => {
                return [...accumulator, ...this.$root.data[current].certificates]
            },[]), 'id').map((chemical) => {
                chemical.title = decodeHTML(this.getProp(chemical, 'title'));
                return chemical
            }).sort(function(a, b) {
                var nameA = a.title.toUpperCase();
                var nameB = b.title.toUpperCase();
                
                if (nameA < nameB) {
                    return -1;
                }

                if (nameA > nameB) {
                    return 1;
                }

                return 0;
            });
        },
        materials() {
            // We will see what `params` is shortly
            return [...Object.values(this.$root.data)].sort((a, b) => Number(a.favorite) - Number(b.favorite));
        }
    },
}
</script>

<style lang="scss" scoped>
    header.blue {
        height: 90px;
    }
    .loader {
        padding: 50px 0;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/views/MaterialFilter.vue